<template>
  <div id="app">
    <div class="imgCon" :style="{height: imgH - StartAnimBefore + 'px' }">
      <div class="frame-container">
        <img
          :style="{ height: imgHeight == 0 ? 'auto' : imgHeight + 'px' }"
          ref="img"
          alt="Vue logo"
          :src="imgSrc"
        />
        <v-spacer class="mobile-only" v-if="this.spacer"></v-spacer>
        <div class="mt-6 mb-3 dt-center"><slot name="text"></slot></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    this.imgH = 500 + this.nFrames * this.frameSpeed;
    const imgCon = document.querySelector(this.containerName + " .imgCon");
    window.addEventListener("scroll", () => {
      if (
        window.scrollY - (imgCon.offsetTop - this.StartAnimBefore) > 0 &&
        window.scrollY - (imgCon.offsetTop - this.StartAnimBefore) <
          this.nFrames * this.frameSpeed
      ) {
        this.imgSrc =
          this.startImgUrl +
          Math.ceil(
            (window.scrollY - (imgCon.offsetTop - this.StartAnimBefore)) /
              this.frameSpeed
          ) +
          ".jpg";
      } else if (
        window.scrollY - (imgCon.offsetTop - this.StartAnimBefore) <=
        1
      ) {
        this.imgSrc = this.startImgUrl + "1.jpg";
      } else {
        this.imgSrc = this.startImgUrl + this.nFrames + ".jpg";
      }
    });
  },
  props: [
    "nFrames",
    "frameSpeed",
    "imgUrl",
    "startImgUrl",
    "containerName",
    "imgHeight",
    "spacer",
    "StartAnimBefore",
  ],
  data() {
    return {
      imgH: 500 + this.nFrames * this.frameSpeed,
      imgSrc: this.imgUrl,
    };
  },
};
</script>

<style scoped>
.frame-container {
  position: sticky;
  top: 0px;
  width: 100%;
  height: 90vh;
  display: flex;
  flex-direction: column;
}
@media (min-width: 950px) {
  .mobile-only{
    display: none !important;
  }
  .dt-center{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .frame-container {
    display: grid;
    grid-template-columns: 1.4fr 1fr;
  }
}
img {
  width: 100%;
  object-fit: cover;
}
</style>
